const state = {
	list: {
		acrobatics:{
			ability:"Dexterity",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		athletics:{
			ability:"Strength",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		bluff:{
			ability:"Charisma",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		computers:{
			ability:"Intelligence",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		culture:{
			ability:"Intelligence",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		diplomacy:{
			ability:"Charisma",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		disguise:{
			ability:"Charisma",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		engineering:{
			ability:"Intelligence",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		intimidate:{
			ability:"Charisma",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		life_science:{
			ability:"Intelligence",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		medicine:{
			ability:"Intelligence",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		mysticism:{
			ability:"Wisdom",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		perception:{
			ability:"Wisdom",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		physical_science:{
			ability:"Intelligence",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		piloting:{
			ability:"Dexterity",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		sense_motive:{
			ability:"Wisdom",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		sleight_of_hand:{
			ability:"Dexterity",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		stealth:{
			ability:"Dexterity",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
		survival:{
			ability:"Wisdom",
			armor_check:false,
			class_skill:false,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:true,
		},
	},
	professions:[
		{
			name:"",
			ability:"",
			armor_check:false,
			class_skill:true,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:false,
		},
		{
			name:"",
			ability:"",
			armor_check:false,
			class_skill:true,
			ranks:{
				1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0,
			},
			bonuses:{
				insight:0,
				misc:0,
				race:0,
				theme:0,
			},
			untrained:false,
		}
	],
	custom:[

	]
}

const getters = {
	get: (state) => (skill, property) => {
		return state.list[skill][property]
	},
	getBonus: (state) => (skill, property) => {
		return state.list[skill].bonuses[property]
	},
	getProfession: (state) => (profession, property) => {
		return state.professions[profession][property]
	},
	getProfessionBonus: (state) => (profession, property) => {
		return state.professions[profession].bonuses[property]
	},
	convertName: () => (name) => {
		var skills = {
			acrobatics:'Acrobatics',
			athletics:'Athletics',
			bluff:'Bluff',
			computers:'Computers',
			culture:'Culture',
			diplomacy:'Diplomacy',
			disguise:'Disguise',
			engineering:'Engineering',
			intimidate:'Intimidate',
			life_science:'Life Science',
			medicine:'Medicine',
			mysticism:'Mysticism',
			perception:'Perception',
			physical_science:'Physical Science',
			piloting:'Piloting',
			sense_motive:'Sense Motive',
			sleight_of_hand:'Sleight of Hand',
			stealth:'Stealth',
			survival:'Survival',
		}
		if( Object.keys(skills).includes(name) ){
			return skills[name]
		}else{
			return name
		}
	},
	used: ( state, getters ) => {
		var skillsUsed = {}
		for( const skill in state.list ){
			skillsUsed[skill] = Object.assign( state.list[skill] )
			skillsUsed[skill].name = getters.convertName( skill )
		}
		return skillsUsed
	},
	ranks: ( state, getters, rootState, rootGetters ) => {
		var currentLevel = rootGetters.currentLevel
		var ranks = {}
		for( const skill in state.list){
			var total = 0
			for(var i=1; i<=currentLevel; i++){
				total += state.list[skill].ranks[i]
			}
			ranks[skill] = total
		}

		return ranks
	},
	ranksAtLevel: (state, getters, rootState) => {
		var levels = rootState.Character.Levels
		var ranks = {}

		for(var i=1; i<= Object.keys(levels).length; i++){
			const level = levels[i]
			if(i == 1){
				ranks[1] = Object.assign({}, level.Skills)
			}else{
				ranks[i] = {}
				for(const skill in level.Skills){
					ranks[i][skill] = (ranks[i-1][skill] + level.Skills[skill])
				}
			}
		}

		return ranks
	},
	ranksAvailable: (state, getters, rootState, rootGetters) => {
		var levels = rootState.Character.Levels
		var ranks = {}

		for(var i=1; i<= Object.keys(levels).length; i++){
			const level = levels[i]
			const intThisLevel = rootGetters['character/abilityScores/abilityModsAtLevel'](i)['Intelligence']
			const intLastLevel = (i == 1) ?  intThisLevel : rootGetters['character/abilityScores/abilityModsAtLevel'](i-1)['Intelligence']

			ranks[i] = level.SkillRanks + rootGetters['character/abilityScores/abilityModsAtLevel'](i)['Intelligence']
			if(intThisLevel > intLastLevel){
				ranks[i] += ( (intThisLevel - intLastLevel) * (i-1) )
			}
		}

		return ranks
	},
	ranksUsed: (state, getters, rootState) => {
		var levels = rootState.Character.Levels
		var ranks = {}

		for(var i=1; i<= Object.keys(levels).length; i++){
			const level = levels[i]
			ranks[i] = 0
			for(const skill in level.Skills){
				ranks[i] += level.Skills[skill]
			}
		}

		return ranks
	},
	other: ( state, getters, rootState, rootGetters ) => {
		var others = {}
		//just the "Other" = Insight + Theme + Race + Misc
		for( const skill in state.list ){
			if( state.list[skill].untrained == false && getters.ranks[skill] < 1 ){
				others[skill] = '-';
			}else{
				//ClassSkill + Insight + Theme + Race + Misc + Armor Check Penalty
				others[skill] = 
					( ( state.list[skill].class_skill === true && getters.ranks[skill] >= 1 ) ? 3 : 0 ) + //class bonus
					parseInt(state.list[skill].bonuses.insight) + //insight
					parseInt(state.list[skill].bonuses.theme) + //theme
					parseInt(state.list[skill].bonuses.race) + //race
					parseInt(state.list[skill].bonuses.misc) + //misc
					( state.list[skill].armor_check === true ? rootGetters.armorCheck : 0 ); //armor check
			}
		}
		return others
	},
	total: ( state, getters, rootState, rootGetters ) => {
		var total = {}
		//Skill cannot be used untrained, and character has no ranks in it
		for( const skill in state.list ){
			if( state.list[skill].untrained == false && getters.ranks[skill] < 1 ){
				total[skill] = '-';
			}else{
				//Ability + Ranks + ClassSkill + Insight + Theme + Race + Misc + Armor Check Penalty
				total[skill] = 
					rootGetters['character/abilityScores/abilityMods'][ state.list[skill].ability ] + //ability mod
					getters.ranks[skill] + //Ranks
					( ( state.list[skill].class_skill === true && getters.ranks[skill] >= 1 ) ? 3 : 0 ) + //class bonus
					parseInt(state.list[skill].bonuses.insight) + //insight
					parseInt(state.list[skill].bonuses.theme) + //theme
					parseInt(state.list[skill].bonuses.race) + //race
					parseInt(state.list[skill].bonuses.misc) + //misc
					( state.list[skill].armor_check === true ? rootGetters.armorCheck : 0 ); //armor check
			}
		}
		return total
	},
}

const actions = {
	loadCharacter( {state, getters}, character ){
		
		for(const skill in state.list){
			var skill_name = getters.convertName(skill)
			state.list[skill].ability = character.Skills[skill_name].Ability
			state.list[skill].armor_check = character.Skills[skill_name].ArmorCheck
			state.list[skill].class_skill = character.Skills[skill_name].ClassSkill
			state.list[skill].untrained = character.Skills[skill_name].Untrained
			state.list[skill].bonuses.insight = character.Skills[skill_name].Insight
			state.list[skill].bonuses.misc = character.Skills[skill_name].Misc
			state.list[skill].bonuses.race = character.Skills[skill_name].Race
			state.list[skill].bonuses.theme = character.Skills[skill_name].Theme
			for(const level in character.Levels){
				state.list[skill].ranks[level] = character.Levels[level].Skills[skill_name]
			}
		}
		state.professions.forEach( (_value, index) => {
			var skill_name = `Profession${index+1}`
			state.professions[index].name = character.Skills[skill_name].Name
			state.professions[index].ability = character.Skills[skill_name].Ability
			state.professions[index].class_skill = character.Skills[skill_name].ClassSkill
			state.professions[index].untrained = character.Skills[skill_name].Untrained
			state.professions[index].bonuses.insight = character.Skills[skill_name].Insight
			state.professions[index].bonuses.misc = character.Skills[skill_name].Misc
			state.professions[index].bonuses.race = character.Skills[skill_name].Race
			state.professions[index].bonuses.theme = character.Skills[skill_name].Theme
			for(const level in character.Levels){
				state.professions[index].ranks[level] = character.Levels[level].Skills[skill_name]
			}
		})
	}
}

const mutations = {
	set (state, payload){
		state.list[payload.skill][payload.property] = payload.value
	},
	setBonus (state, payload){
		state.list[payload.skill].bonuses[payload.property] = payload.value
	},
	setProfession (state, payload){
		state.professions[payload.profession][payload.property] = payload.value
	},
	setProfessionBonus (state, payload){
		state.professions[payload.profession].bonuses[payload.property] = payload.value
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}